<template>
	<ModalFormCard
		:action="
			'/subscription/' +
			this.subscription.id +
			'/set-default-payment-method'
		"
		class="modal-default"
	>
		<template #title>Update payment method</template>

		<template #default="{ saving, errors }">
			<SelectCard 
				v-model:value="value.card_id"
				:disabled="saving"
				:options="options.cards"
				valueKey="id"
				:lastModal="{
					view: 'SubscriptionUpdatePaymentMethod',
					editingModel: this.editingModel,
					options: { ...this.options, currentValue: this.value },
				}"
			/>

			<!-- <Select
				v-model:value="value.card_id"
				:disabled="saving"
				:options="options.cards"
				label="Select card"
				menuClass="!bg-grey"
				menuMaxHeight="80px"
				name="card_id"
				placeholder="Select a card"
				selectClass="!bg-grey text-15"
				selectedCSS=""
				valueKey="id"
			>
				<template #option="{ option, selected }">
					<div class="flex items-center w-full">
						<PaymentMethodTable
							:paymentMethod="option"
							:table="false"
						/>

						<div
							v-if="option.default_payment_method != null"
							class="flex items-center ml-4"
						>
							<IconTrue
								class="stroke-white w-5 h-5 bg-black rounded-full"
							/>

							<p class="text-15 pl-2">Default</p>
						</div>
					</div>
				</template>
			</Select> -->

			<p class="mt-4 text-grey-900 text-14">
				Your billing date will remain the same and you will be charged
				as normal on the
				{{
					$moment(
						subscription.current_ad_period.ads_period_to,
					).format("Do MMMM YYYY")
				}}.
			</p>

			<div class="pt-6">
				<ButtonSaving :disabled="saving" class="button-black h-12 px-6">
					Update card
				</ButtonSaving>
			</div>
		</template>
	</ModalFormCard>
</template>

<script>
import Modal from "~/mixins/modal.js";

export default {
	mixins: [Modal],

	created() {
		this.value.card_id =
			this.subscription.stripe_payment_method_id != null
				? this.options.cards.find(
						(c) =>
							c.stripe_card_id ==
							this.subscription.stripe_payment_method_id,
				  ).id
				: this.options.cards.find(
						(c) => c.default_payment_method != null,
				  ).id;
	},

	data() {
		return {
			value: {
				card_id: null,
			},
		};
	},

	computed: {
		subscription() {
			return this.editingModel;
		},
	},
};
</script>
